import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import counter from './slices/counter';
import studentbehavior from './slices/studentbehavior';
import enrollment from './slices/enrollment';
import schoolperformance from './slices/schoolperformance';
import studentperformance from './slices/studentperformance';
import strengthweakness from './slices/strengthweakness';
import filter from './slices/filter';
import  statebenchmarking  from './slices/statebenchmarking';
import annualplandashboard from './slices/annualplandashboard';
import staffdetails from './slices/staffdetails';
import User from './slices/user';
import attendance from './slices/attendance';


const reducer = combineReducers({
  'user': User,
  'netsales': counter,
  'studentbehavior': studentbehavior,
  'enrollment': enrollment,
  'schoolperformance': schoolperformance,
  'studentperformance': studentperformance,
  'strengthweakness': strengthweakness,
  'filter':filter,
  'statebenchmarking':statebenchmarking,
  'annualplandashboard':annualplandashboard,
  'staffdetails': staffdetails,
  'attendance': attendance
})
const store = configureStore({
  reducer,
})
export default store;